module.exports = __webpack_public_path__ + "media/site_templates/www.localfencingcompanies.com.au/images/feature_3-57d6f5ab34c48939b7846dc9332777ee.jpeg";